import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      'bg-surface-primary pointer-events-none fixed inset-y-0 left-0 w-screen',
      className
    )}
  >
    <div
      className={twMerge(
        'page-bg absolute inset-0 bg-(image:--page-bg-image) bg-position-[-76px_bottom] bg-no-repeat md:bg-size-[auto_100%] md:bg-bottom-right'
      )}
    />
  </div>
);
